export default "__VITE_ASSET__0bb024ce__"